var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 13.5h14.4c.442 0 .8.336.8.75 0 .385-.309.702-.707.745L19.2 15H4.8c-.442 0-.8-.336-.8-.75 0-.385.309-.702.707-.745L4.8 13.5h14.4H4.8Zm0-4.5h14.4c.442 0 .8.336.8.75 0 .385-.309.702-.707.745l-.093.005H4.8c-.442 0-.8-.336-.8-.75 0-.385.309-.702.707-.745L4.8 9h14.4H4.8Z",
    fill: "#666"
  })));
};
export default SvgSort;